import { Badge, Chip, Grid, IconButton, Typography } from "@mui/material";
import ColumnContainer from "../../../common/ColumnContainer";
import RowContainer from "../../../common/RowContainer";
import { ChartContainer } from "./style";
import { useEffect, useState } from "react";
import { ArrowForwardIosRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { userDashboardRoute } from "../../../../utils/routes/Routes";
import { FormattedMessage } from "react-intl";

const TicketsReview = ({ data }) => {
  const navigate = useNavigate();
  const [ticketReviewData, setTicketReviewData] = useState([]);
  // ticket updated in the last 3 days:
  const recentTickets = data?.not_filtered_tickets?.filter((item) => {
    const today = new Date();
    const ticketDate = new Date(item.updated_at);
    const diffTime = Math.abs(today - ticketDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 3;
  });

  useEffect(() => {
    if (data?.counters) {
      const remappedData = [
        {
          id: 1,
          value: data?.counters?.total_open_tickets,
          label: <FormattedMessage id="dashboard.review.tickets.open" />,
          ids: data?.not_filtered_tickets?.reduce(
            (acc, curr) => (curr.status === "open" ? [...acc, curr.id] : acc),
            []
          ),
        },
        {
          id: 2,
          value: data?.counters?.total_in_progress_tickets,
          label: <FormattedMessage id="dashboard.review.tickets.inProgress" />,
          ids: data?.not_filtered_tickets?.reduce(
            (acc, curr) =>
              curr.status === "in_progress" ? [...acc, curr.id] : acc,
            []
          ),
        },
        {
          id: 3,
          value: data?.counters?.total_completed_tickets,
          label: <FormattedMessage id="dashboard.review.tickets.completed" />,
          ids: data?.not_filtered_tickets?.reduce(
            (acc, curr) =>
              curr.status === "completed" ? [...acc, curr.id] : acc,
            []
          ),
        },
        {
          id: 4,
          value: data?.counters?.total_closed_tickets,
          label: <FormattedMessage id="dashboard.review.tickets.closed" />,
          ids: data?.not_filtered_tickets?.reduce(
            (acc, curr) => (curr.status === "closed" ? [...acc, curr.id] : acc),
            []
          ),
        },
      ];
      setTicketReviewData(remappedData);
    }
  }, [data]);

  const handleGoToTickets = () => {
    navigate(userDashboardRoute.tickets);
  };
  return (
    <ChartContainer>
      <ColumnContainer>
        <RowContainer align="center">
          <Typography variant="h6" color="var(--main-color)">
            <FormattedMessage id="dashboard.review.tickets" />
          </Typography>
          <IconButton>
            <ArrowForwardIosRounded onClick={() => handleGoToTickets()} />
          </IconButton>
        </RowContainer>
        {ticketReviewData.map((item) => (
          <Grid container spacing={2} key={item?.id}>
            <Grid item xs={12} sm={6}>
              <RowContainer halfGap start align="center">
                <Typography variant="p">{item.label}</Typography>
              </RowContainer>
            </Grid>
            <Grid item xs={12} sm={6} alignContent={"flex-end"}>
              <Badge
                badgeContent={"New!"}
                overlap="rectangular"
                color="warning"
                invisible={
                  !recentTickets?.some((recent) => item.ids.includes(recent.id))
                }
                sx={{ "& .MuiBadge-badge": { right: "-8px", top: "0px" } }}
              >
                <Chip
                  variant="outlined"
                  color="warning"
                  label={
                    <Typography variant="p" color="var(--main-color)">
                      {item.value}
                    </Typography>
                  }
                ></Chip>
              </Badge>
            </Grid>
          </Grid>
        ))}
      </ColumnContainer>
    </ChartContainer>
  );
};
export default TicketsReview;
